import React, { useState } from 'react'
import ExpenseDetails from './ExpenseDetails'
import LiabilityPayback from '../Liability/LiabilityPayback'
import TabLine from 'components/Tabs/TabLine'
import CashflowPageHeader from './CashflowPageHeader'
import LiabilityInfo from 'myFinancials/Liability/LiabilityInfo'
import ExpenseProjection from './ExpenseProjection'
import NoFinancialData from 'myFinancials/Template/NoFinancialData'
import { useAppInfo } from 'AppState'

export default function ExpenseInfo({info,displayType="tabs"}) {
  const [tabIndex,setTabIndex]  = useState(0)
  const tabList = ["Details","Liability Payback"]
  const {stateMyFinancials} = useAppInfo()
  const {expenseMonthly,financialsLoaded} = stateMyFinancials

  const content = {
    "Details":<ExpenseDetails/>,
    "Liability Payback":<LiabilityInfo info={"Payback"}/>,
    "Projections":<ExpenseProjection/>
  }
  
  if (financialsLoaded && expenseMonthly.length === 0)  {
    return (
    <div style={{position:"relative",width:"100%",height:"100%",minHeight:"50vh"}}>
    <NoFinancialData financialType='expenses'/></div>)
  }

  return (
    <div className='containerColumnFlex'>
    {displayType === "tabs" && <CashflowPageHeader type="Expense" title="Expense"/>}
    {displayType === "tabs" && <TabLine tabList={tabList} tabIndex={tabIndex} handleTabChange={(i)=>setTabIndex(i)}/>}
    <div className='containerColumnFlex1'>
    {content[tabList[tabIndex]]}
    </div>
    </div>
  )
}
